module.exports = __webpack_public_path__ + "static/media/fly0169.65585509.webp";